var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const StackedList = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('h-full overflow-y-auto isolate', className) }, rest), children));
};
const StackedListGroup = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('relative', className) }, rest), children));
};
const StackedListGroupTitle = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: clsx('z-10 sticky top-0 border-t border-b border-line-subdued bg-surface-subdued px-6 py-1 text-sm font-medium text-content-subdued', className) }, rest), children));
};
StackedList.Group = StackedListGroup;
StackedList.GroupTitle = StackedListGroupTitle;
//# sourceMappingURL=StackedList.js.map